/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import React from "react";
import {StreamBankTable} from "../../../../Common/Table/StreamBankTable";
import {customListName, organization} from "./ColumnDefinitions";

export const SpeciesListTable = React.forwardRef((props, ref) => {
    
    const columnDefs = [
        customListName,
        organization
    ];
    
    return <StreamBankTable
        columnDefs={columnDefs}
        itemNamePlural="species lists"
        getKeyForRow={x => x.speciesListId}
        
        sortAsc={true}

        ref={ref}

        {...props}

    />;
});


